<template>
  <SettingsPageLayout>
    <DashboardQuickstart @handle-setup-complete="handleSetupComplete" />
  </SettingsPageLayout>
</template>

<script setup lang="ts">
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { onMounted } from 'vue';
import SettingsPageLayout from '../SettingsPageLayout/index.vue';
import DashboardQuickstart from '../dashboard_quickstart/DashboardQuickstart.vue';

const store = useStore();
const router = useRouter();

const handleSetupComplete = () => {
  router.push('/settings/account/profile');
  store.commit('general/showAlert', {
    alertType: 'success',
    alertTitle: 'Guided Account Setup Complete!',
    alertDescription:
      'Congrats, you have completed the guided account setup. Use the button below to dismiss this alert.',
  });
};

onMounted(() => {
  store.commit('general/hideSetupBanner');
});
</script>
